import { type Config, config } from "@repo/config";
import { createPurchasesHelper } from "@repo/payments/lib/helper";
import { usePurchasesQuery } from "@saas/payments/lib/api";

const plans = config.payments.plans as Config["payments"]["plans"];

export const usePurchases = (organizationId?: string) => {
	const { data: purchasesData, isLoading } =
		usePurchasesQuery(organizationId);

	// 确保purchases是数组
	const purchases = Array.isArray(purchasesData) ? purchasesData : [];
	const { activePlan, hasSubscription, hasPurchase } =
		createPurchasesHelper(purchases);

	return {
		purchases,
		activePlan,
		hasSubscription,
		hasPurchase,
		loading: isLoading,
	};
};

export const useUserPurchases = () => usePurchases();

export const useOrganizationPurchases = (organizationId: string) =>
	usePurchases(organizationId);
